import { createContext } from 'react';
import { Locale } from 'date-fns';
import { AVAILABLE_LOCALES } from '../i18n/localeConfig';

export interface LocaleConfig {
  // name of the file containing the locale's translations
  messageFile: string;
  // Locale title to show in screens
  title: string;
  // actual locale code to use for localisation
  localeCode: string;
  // code inside the urls for impressum and dataprotection
  publicationCode: string;
  // Locale class for usage in dateFns
  dateFnsLocale: Locale;
}

// Context interface for the LocalisationProvider
export interface LocalisationContext {
  currentConfig: LocaleConfig;

  // method to change the locale in the context
  setLocale: (configKey: string) => void;
}

export const defaultConfig: LocaleConfig = AVAILABLE_LOCALES.en;

export const IntlContext = createContext<LocalisationContext>({
  currentConfig: defaultConfig,
  setLocale(): void {},
});
